module.exports = "<app-slider></app-slider>\r\n<app-brands></app-brands>\r\n<app-advertisements></app-advertisements>\r\n<app-trending></app-trending>\r\n<app-categories></app-categories>\r\n\r\n<app-package></app-package> \r\n<app-blog></app-blog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.component.html
// module id = ./src/app/pages/home/home.component.html
// module chunks = main